export const normalMaxTagsDisplay = 9;
export const shortMaxTagsDisplay = 2;
export const mediumMaxTagsDisplay = 5;